import { FC } from 'react'
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/ui/Alert/AlertDialog'
import { AlertDialog, AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { Loader } from '@mantine/core'
import { useDeleteResidentialAmenity } from '../lib/use-delete-residential-amenity'
import { useTranslation } from 'react-i18next'

type DeleteResidentialAmenityAlertProps = {
  selectResidentialAmenityId: number
  onCloseModal: () => void
}

export const DeleteResidentialAmenityAlert: FC<
  DeleteResidentialAmenityAlertProps & AlertDialogProps
> = ({ selectResidentialAmenityId, onCloseModal, ...props }) => {
  const { isLoadingDelete, handleDeleteResidentialAmenity } = useDeleteResidentialAmenity()
  const { t } = useTranslation(['anemity'])

  return (
    <AlertDialog {...props}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('amenity:confirmation.are_you_absolutely_sure')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('amenity:confirmation.action_cannot_be_undone')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoadingDelete}>
            {t('amenity:buttons.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={isLoadingDelete}
            className='bg-red hover:bg-red/80'
            onClick={() => handleDeleteResidentialAmenity(selectResidentialAmenityId, onCloseModal)}
          >
            {isLoadingDelete ? <Loader color='white' size='xs' /> : t('amenity:buttons.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
